import React, { useCallback, useEffect, useState } from "react";
import { Button, Tooltip, Typography } from "antd";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import { connect, useDispatch, useSelector } from "react-redux";
import { debounce } from "lodash";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

import { RecentPatientsTable } from "./TableSection/RecentPatientsTable";
import ACTIONS from "../store/action";
import { GRAY_900, WHITE } from "../constant/colors";
import { fontWeights, sizes } from "../constant/styles";
import ArrowBack from "../assets/svg/ArrowBack";
import { Routes } from "../constant/routes";
import {
  selectFilterList,
  selectSearchResultPage,
  selectShouldReturnToRelevantPatient,
  selectPreviousPage
} from "../store/selector";

const { Text } = Typography;

const ContainerStyle = styled.div`
  margin: 0px 15px 0px 15px;
  position: relative;
  background: ${WHITE};
  border-radius: 10px;
  padding: 10px 15px 0px 15px;
`;

const BackButtonStyle = styled(Button)`
  background-color: transparent;
  border: none;
  padding: 0px;
`;

const SearchResultLblStyle = styled(Text)`
  font-size: ${sizes.medium_xlarge};
  font-weight: ${fontWeights.semibold};
  color: ${GRAY_900};
`;

const RecentPatientsComponent = ({ t, recentPatientsAct }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [startSearch, setStartSearch] = useState(false);

  const savedFilter = useSelector(selectFilterList);
  const searchResultPage = useSelector(selectSearchResultPage);
  const previousPage = useSelector(selectPreviousPage);

  const shouldReturnToRelevantPatientAct = (shouldReturn, notificationId) =>
    dispatch(ACTIONS.setShouldReturnToRelevantPatient(shouldReturn, notificationId));
  const shouldReturnToRelevantPatient = useSelector(selectShouldReturnToRelevantPatient);

  const { notificationId: topOpportunitiesNotificationId } = shouldReturnToRelevantPatient;

  useEffect(() => {
    debouncedSearch(1);
  }, []);

  const debouncedSearch = useCallback(
    debounce((page) => {
      setStartSearch(true);
      recentPatientsAct(page);
    }, 500),
    []
  );

  return (
    <ContainerStyle>
      <Tooltip title={t("back")}>
        <BackButtonStyle
          type="text"
          onClick={() => {
            if (shouldReturnToRelevantPatient.shouldReturn) {
              history.push(Routes.ROOT + `${Routes.TOP_OPPORTUNITIES}${topOpportunitiesNotificationId}`, {
                notification: topOpportunitiesNotificationId
              });
              shouldReturnToRelevantPatientAct(false, null);
            } else if (savedFilter?.id) {
              history.push(`${Routes.FILTER_LIST}/${savedFilter.id}`);
            } else if (searchResultPage?.wasSearchResultPage) {
              history.push(`${Routes.SEARCH_RESULTS}?searchBy=${searchResultPage?.searchBy}`, {
                searchText: searchResultPage?.searchText
              });
            } else {
              // return to the last page that opened this link
              history.push(
                previousPage?.pathname
                  ? `${previousPage.pathname}${previousPage.search}${previousPage.hash}`
                  : Routes.ROOT,
                previousPage?.pathname ? previousPage.state : null
              );
            }
          }}
        >
          <ArrowBack />
        </BackButtonStyle>
      </Tooltip>

      <div style={{ paddingBottom: "15px" }}>
        <SearchResultLblStyle>{t("recently_viewed_patients")}</SearchResultLblStyle>
      </div>

      <RecentPatientsTable startSearch={startSearch} fetchOrders={(page) => debouncedSearch(page)} />
    </ContainerStyle>
  );
};

const mapDispatchToProps = (dispatch) => ({
  recentPatientsAct: (page) => dispatch(ACTIONS.getRecentPatientsAction(page))
});

const RecentPatients = compose(withTranslation(), connect(null, mapDispatchToProps))(RecentPatientsComponent);
export { RecentPatients };
